import {
  AfterViewInit,
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatColumnDef, MatHeaderRowDef, MatNoDataRow, MatRowDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { SHA1 } from 'crypto-js';
import { API_PAGE_LIMIT } from '../../../../aop-eop-core/src/app/constants/api.constant';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class TableComponent implements AfterViewInit {
  @Input('items') public items: any[] = [];
  public dataSource!: MatTableDataSource<any>;
  @ViewChild(MatTable, {static: true}) public table!: MatTable<any>;
  @ViewChild(MatPaginator) public paginator!: MatPaginator;
  public lastHash!: string;
  @Output() public endOfTable: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @ViewChild(MatPaginator) public matPaginator!: MatPaginator;
  @Input() public pageSizeOptions: number[] | readonly number[] = Array.from(
    { length: 5 },
    (_, i) => (i + 1) * 10
  );
  public pageSize: number = API_PAGE_LIMIT / 2;
  @Input()
  public hidePageSize = false;
  @ContentChildren(MatHeaderRowDef)
  public headerRowDefs!: QueryList<MatHeaderRowDef>;
  @ContentChildren(MatRowDef)
  public rowDefs!: QueryList<MatRowDef<any>>;
  @ContentChildren(MatColumnDef)
  public columnDefs!: QueryList<MatColumnDef>;
  @ContentChild(MatNoDataRow)
  public noDataRow!: MatNoDataRow;

  constructor() {}

  ngAfterViewInit(): void {
    this.initPaginator();
  }

  ngAfterContentInit() {
    this.columnDefs.forEach((columnDef) => this.table.addColumnDef(columnDef));
    this.rowDefs.forEach((rowDef) => this.table.addRowDef(rowDef));
    this.headerRowDefs.forEach((headerRowDef) =>
      this.table.addHeaderRowDef(headerRowDef)
    );
    this.table.setNoDataRow(this.noDataRow);
  }

  ngDoCheck(): void {
    const hash = SHA1(JSON.stringify(this.items)).toString();

    if (this.lastHash != hash) {
      this.lastHash = hash;
      this.initPaginator();
    }
  }

  public pageChange(d: PageEvent) {
    const hasNextPage = this.matPaginator.hasNextPage();

    if (!hasNextPage) {
      this.endOfTable.emit(true);
    }
  }

  private initPaginator(): void {
    if (this.items?.length) {
      this.dataSource = new MatTableDataSource([...this.items]);
      this.dataSource.paginator = this.paginator;
    }
  }
}
